<template>
  <div class="login-layout-container">
    <div class="main">
      <div class="header-header">
        <nav class="navbar">
          <div v-if="isMobileMenuOpen" class="mobile-menu has-logout">
            <div>
              <div
                @click="toggleDropdown"
                style="
                  padding: 10px;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <span>
                  {{ userProfile.first_name }} {{ userProfile.last_name }}
                </span>
                <span class="dropdown-arrow" :class="{ open: isDropdownOpen }"
                  ><svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1.70492L10.59 0.294922L6 4.87492L1.41 0.294921L-6.16331e-08 1.70492L6 7.70492L12 1.70492Z"
                      fill="black"
                    />
                  </svg>
                </span>
              </div>
              <div v-if="isDropdownOpen">
                <router-link  v-if="!userProfile?.is_insurance"
                  class="mobile-link has-icon"
                  :to="
                    careType == 'Care seeker'
                      ? '/careseeker/my-jobs'
                      : '/caregiver/my-jobs'
                  "
                  @click="toggleMobileMenu"
                >
                  <svg
                    width="19"
                    height="16"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1077 4.11247V7.29252C18.0109 7.70601 17.8443 8.08647 17.5573 8.40367C17.4511 8.52073 17.4114 8.64393 17.4119 8.80159C17.4162 10.6444 17.4152 12.4876 17.4143 14.3304C17.4138 15.3099 16.7275 15.9953 15.7438 15.9953C11.2921 15.9962 6.84087 15.9901 2.38919 16C1.36536 16.0024 0.689422 15.1692 0.701694 14.3205C0.7286 12.4777 0.708303 10.6345 0.712551 8.79167C0.712551 8.64063 0.671485 8.52451 0.572359 8.40981C0.189545 7.96563 -0.00823382 7.45395 0.000262663 6.85778C0.0125354 6.03929 0.0045109 5.22079 0.00309482 4.4023C0.0026228 4.0209 0.129126 3.68671 0.370332 3.39547C0.722935 2.9697 1.19166 2.80402 1.73071 2.80307C2.54921 2.80213 3.3677 2.80307 4.18619 2.80213C4.4071 2.80213 4.41938 2.78891 4.41985 2.57461C4.42079 2.2744 4.4189 1.97419 4.42079 1.67351C4.42646 0.762973 5.15668 0.00914686 6.06533 0.00584267C8.06153 -0.00218178 10.0577 -0.00170976 12.0535 0.00584267C12.964 0.00914686 13.6971 0.759669 13.7037 1.66879C13.7056 1.96334 13.7037 2.25741 13.7046 2.55195C13.7046 2.79458 13.7117 2.8026 13.9505 2.8026C14.7516 2.80354 15.5521 2.80166 16.3532 2.80354C16.5948 2.80402 16.836 2.82243 17.0654 2.90928C17.629 3.12263 17.9566 3.54132 18.1077 4.11247ZM9.0561 3.91234C6.60722 3.91234 4.15787 3.91234 1.709 3.91234C1.29362 3.91234 1.09253 4.11389 1.09159 4.53163C1.0897 5.29679 1.09112 6.06242 1.09159 6.82757C1.09159 7.17215 1.20723 7.47236 1.439 7.7282C1.59005 7.8953 1.76092 8.03832 1.94784 8.16294C2.59877 8.59673 3.32663 8.84596 4.07338 9.04799C5.00752 9.30052 5.96102 9.43741 6.92253 9.52898C7.19348 9.55494 7.21094 9.54833 7.21283 9.27031C7.21377 9.12398 7.19489 8.97529 7.269 8.83793C7.4007 8.59342 7.62208 8.52687 7.87792 8.52687C8.66667 8.52687 9.4559 8.52592 10.2447 8.52781C10.3263 8.52781 10.4099 8.53678 10.4896 8.55377C10.7327 8.60617 10.8994 8.80631 10.9121 9.05459C10.9164 9.13673 10.9135 9.21933 10.914 9.30194C10.9149 9.53984 10.9409 9.56202 11.183 9.53323C11.5569 9.48886 11.9312 9.45204 12.3036 9.39917C13.3081 9.25568 14.2956 9.04279 15.2387 8.65668C15.7258 8.45748 16.1889 8.21533 16.575 7.84762C16.8861 7.55166 17.0414 7.19575 17.0366 6.76196C17.0286 6.03221 17.0348 5.30198 17.0343 4.57176C17.0343 4.09737 16.8464 3.91186 16.3683 3.91186C13.9312 3.91186 11.4936 3.91186 9.05657 3.91186L9.0561 3.91234ZM9.06318 14.8865C11.2826 14.8865 13.5026 14.887 15.7221 14.886C16.1247 14.886 16.3258 14.6925 16.3267 14.2965C16.3296 12.7128 16.3267 11.1292 16.33 9.54503C16.33 9.39304 16.2946 9.37416 16.1615 9.4426C15.562 9.75083 14.9248 9.96089 14.2739 10.1285C13.2689 10.3871 12.2479 10.5519 11.2133 10.6264C11.0051 10.6415 10.8323 10.6784 10.7998 10.9314C10.7903 11.0036 10.7445 11.0735 10.7068 11.1395C10.2904 11.8693 9.63716 12.1435 8.83235 12.0642C8.079 11.9897 7.55835 11.5776 7.3011 10.8601C7.24965 10.7161 7.1812 10.651 7.03204 10.6392C6.48119 10.5948 5.93222 10.5311 5.38561 10.4471C4.21121 10.2668 3.06844 9.97646 1.99363 9.45487C1.86367 9.39194 1.79853 9.43379 1.79821 9.58043C1.79821 11.123 1.79821 12.6656 1.79821 14.2082C1.79821 14.717 1.96673 14.8855 2.47557 14.8855C4.67144 14.8855 6.86778 14.8855 9.06365 14.8855L9.06318 14.8865ZM9.06223 2.8026C9.23263 2.8026 9.40351 2.8026 9.57391 2.8026C10.5095 2.8026 11.4445 2.8026 12.3801 2.8026C12.6067 2.8026 12.6171 2.7908 12.6175 2.56092C12.618 2.29612 12.6208 2.03131 12.6166 1.76697C12.6095 1.34357 12.3796 1.11322 11.9572 1.11322C10.0275 1.11133 8.09788 1.11133 6.16824 1.11322C5.74436 1.11322 5.51542 1.34262 5.50881 1.7665C5.50457 2.02517 5.5074 2.28432 5.50787 2.54299C5.50787 2.79599 5.51353 2.80307 5.76229 2.80307C6.86259 2.80354 7.96241 2.80307 9.0627 2.80307L9.06223 2.8026ZM8.29849 10.0931C8.29047 10.3163 8.30132 10.583 8.52176 10.7926C8.70208 10.9644 8.92157 10.971 9.14814 10.9635C9.50546 10.9517 9.74101 10.7511 9.80898 10.3985C9.8458 10.2063 9.81606 10.0114 9.82786 9.81786C9.83635 9.6772 9.77263 9.63235 9.63905 9.63472C9.32751 9.64038 9.01597 9.63472 8.70443 9.6366C8.24798 9.63896 8.30321 9.58846 8.29896 10.0931H8.29849Z"
                      fill="#082F21"
                    />
                  </svg>

                  Jobs</router-link
                >
                <router-link v-if="!userProfile?.is_insurance"
                  class="mobile-link has-icon"
                  to="/messages"
                  @click="toggleMobileMenu"
                >
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7645 7.13988C16.767 7.88014 16.7601 8.62039 16.7412 9.36065C16.6871 11.4914 14.9901 13.3632 12.8725 13.5983C12.0923 13.6849 11.3082 13.6333 10.5256 13.645C9.90317 13.6542 9.30552 13.7691 8.76627 14.0961C8.51757 14.247 8.2825 14.4208 8.04499 14.5892C7.51012 14.9683 6.98109 15.3552 6.44378 15.7304C5.58429 16.3305 4.41235 15.8803 4.17387 14.8583C4.11206 14.594 4.1359 14.3288 4.22059 14.0684C4.3116 13.7895 4.20891 13.643 3.91397 13.6474C3.39565 13.6547 2.88025 13.6469 2.38869 13.4566C1.00065 12.9188 0.204429 11.9177 0.0272742 10.4314C0.00147971 10.2133 0.00245261 9.99529 0.00245261 9.77726C0.0029393 8.38094 -0.00728053 6.98463 0.010727 5.58881C0.0199741 4.86267 0.0311672 4.13409 0.174254 3.41525C0.497416 1.78971 1.96089 0.389017 3.59665 0.141779C4.42792 0.0162131 5.26502 0.0113463 6.10164 0.00696609C7.789 -0.00179432 9.47684 -0.00471451 11.1642 0.0128063C11.8903 0.0201066 12.6184 0.0327606 13.3382 0.17244C14.9711 0.490249 16.381 1.95762 16.6312 3.59727C16.7334 4.26598 16.7392 4.93859 16.7611 5.61071C16.7777 6.12027 16.7645 6.63032 16.7645 7.14037V7.13988ZM8.392 1.22174V1.21931C7.63326 1.21931 6.87402 1.21931 6.11527 1.21931C5.35701 1.2198 4.59875 1.22515 3.84438 1.32638C2.73667 1.47482 1.68494 2.40099 1.40022 3.4829C1.2474 4.06401 1.2328 4.66118 1.22648 5.25348C1.20993 6.88681 1.21626 8.52014 1.21966 10.153C1.2221 11.1585 1.91758 12.0681 2.88317 12.3499C3.24964 12.457 3.62585 12.454 4.00207 12.455C4.99734 12.4575 5.68406 13.3758 5.40762 14.3302C5.38913 14.394 5.36771 14.4592 5.36382 14.5249C5.35263 14.7308 5.53465 14.8495 5.72008 14.7561C5.79551 14.7181 5.86365 14.6651 5.93276 14.6159C6.55524 14.1716 7.17479 13.7228 7.80067 13.2829C8.56088 12.749 9.40334 12.455 10.3378 12.455C11.0177 12.455 11.6971 12.4424 12.377 12.4244C13.7505 12.3883 14.9351 11.5191 15.3779 10.2206C15.522 9.79867 15.5415 9.36211 15.5458 8.92701C15.5585 7.75555 15.558 6.58311 15.5468 5.41165C15.542 4.89089 15.5181 4.36965 15.4471 3.85133C15.2933 2.73145 14.372 1.6841 13.2769 1.3989C12.6895 1.24559 12.0865 1.2378 11.4878 1.2271C10.4561 1.2086 9.42378 1.22223 8.39152 1.22223L8.392 1.22174Z"
                      fill="#082F21"
                    />
                    <path
                      d="M8.37954 8.98194C7.34143 8.98194 6.30332 8.98341 5.26521 8.98097C5.00386 8.98048 4.79653 8.82718 4.7099 8.58627C4.62667 8.35509 4.69919 8.08595 4.88949 7.9268C5.00094 7.83336 5.12894 7.79102 5.27543 7.79102C7.34581 7.79199 9.4157 7.79102 11.4861 7.79248C11.8306 7.79248 12.0964 8.05383 12.0998 8.38283C12.1032 8.71621 11.8316 8.98097 11.4759 8.98146C10.4436 8.9834 9.4118 8.98243 8.37954 8.98146V8.98194Z"
                      fill="#082F21"
                    />
                    <path
                      d="M6.82891 5.88211C6.31935 5.88211 5.80978 5.88551 5.30022 5.88065C5.01259 5.87821 4.78044 5.7069 4.70403 5.45771C4.62518 5.20074 4.71425 4.94231 4.93569 4.78316C5.0598 4.69458 5.20191 4.6683 5.34938 4.66782C6.33833 4.66636 7.32728 4.66441 8.31575 4.6683C8.72019 4.66976 8.983 4.92041 8.98056 5.28299C8.97813 5.64265 8.71045 5.88016 8.30261 5.88113C7.81105 5.88259 7.31998 5.88113 6.82843 5.88113L6.82891 5.88211Z"
                      fill="#082F21"
                    />
                  </svg>

                  Messages</router-link
                >
                 <router-link v-if="careType == 'Care seeker' && !userProfile?.is_insurance"
                  class="mobile-link has-icon"
                  to="/careseeker/hired"
                  @click="toggleMobileMenu"
                >
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7645 7.13988C16.767 7.88014 16.7601 8.62039 16.7412 9.36065C16.6871 11.4914 14.9901 13.3632 12.8725 13.5983C12.0923 13.6849 11.3082 13.6333 10.5256 13.645C9.90317 13.6542 9.30552 13.7691 8.76627 14.0961C8.51757 14.247 8.2825 14.4208 8.04499 14.5892C7.51012 14.9683 6.98109 15.3552 6.44378 15.7304C5.58429 16.3305 4.41235 15.8803 4.17387 14.8583C4.11206 14.594 4.1359 14.3288 4.22059 14.0684C4.3116 13.7895 4.20891 13.643 3.91397 13.6474C3.39565 13.6547 2.88025 13.6469 2.38869 13.4566C1.00065 12.9188 0.204429 11.9177 0.0272742 10.4314C0.00147971 10.2133 0.00245261 9.99529 0.00245261 9.77726C0.0029393 8.38094 -0.00728053 6.98463 0.010727 5.58881C0.0199741 4.86267 0.0311672 4.13409 0.174254 3.41525C0.497416 1.78971 1.96089 0.389017 3.59665 0.141779C4.42792 0.0162131 5.26502 0.0113463 6.10164 0.00696609C7.789 -0.00179432 9.47684 -0.00471451 11.1642 0.0128063C11.8903 0.0201066 12.6184 0.0327606 13.3382 0.17244C14.9711 0.490249 16.381 1.95762 16.6312 3.59727C16.7334 4.26598 16.7392 4.93859 16.7611 5.61071C16.7777 6.12027 16.7645 6.63032 16.7645 7.14037V7.13988ZM8.392 1.22174V1.21931C7.63326 1.21931 6.87402 1.21931 6.11527 1.21931C5.35701 1.2198 4.59875 1.22515 3.84438 1.32638C2.73667 1.47482 1.68494 2.40099 1.40022 3.4829C1.2474 4.06401 1.2328 4.66118 1.22648 5.25348C1.20993 6.88681 1.21626 8.52014 1.21966 10.153C1.2221 11.1585 1.91758 12.0681 2.88317 12.3499C3.24964 12.457 3.62585 12.454 4.00207 12.455C4.99734 12.4575 5.68406 13.3758 5.40762 14.3302C5.38913 14.394 5.36771 14.4592 5.36382 14.5249C5.35263 14.7308 5.53465 14.8495 5.72008 14.7561C5.79551 14.7181 5.86365 14.6651 5.93276 14.6159C6.55524 14.1716 7.17479 13.7228 7.80067 13.2829C8.56088 12.749 9.40334 12.455 10.3378 12.455C11.0177 12.455 11.6971 12.4424 12.377 12.4244C13.7505 12.3883 14.9351 11.5191 15.3779 10.2206C15.522 9.79867 15.5415 9.36211 15.5458 8.92701C15.5585 7.75555 15.558 6.58311 15.5468 5.41165C15.542 4.89089 15.5181 4.36965 15.4471 3.85133C15.2933 2.73145 14.372 1.6841 13.2769 1.3989C12.6895 1.24559 12.0865 1.2378 11.4878 1.2271C10.4561 1.2086 9.42378 1.22223 8.39152 1.22223L8.392 1.22174Z"
                      fill="#082F21"
                    />
                    <path
                      d="M8.37954 8.98194C7.34143 8.98194 6.30332 8.98341 5.26521 8.98097C5.00386 8.98048 4.79653 8.82718 4.7099 8.58627C4.62667 8.35509 4.69919 8.08595 4.88949 7.9268C5.00094 7.83336 5.12894 7.79102 5.27543 7.79102C7.34581 7.79199 9.4157 7.79102 11.4861 7.79248C11.8306 7.79248 12.0964 8.05383 12.0998 8.38283C12.1032 8.71621 11.8316 8.98097 11.4759 8.98146C10.4436 8.9834 9.4118 8.98243 8.37954 8.98146V8.98194Z"
                      fill="#082F21"
                    />
                    <path
                      d="M6.82891 5.88211C6.31935 5.88211 5.80978 5.88551 5.30022 5.88065C5.01259 5.87821 4.78044 5.7069 4.70403 5.45771C4.62518 5.20074 4.71425 4.94231 4.93569 4.78316C5.0598 4.69458 5.20191 4.6683 5.34938 4.66782C6.33833 4.66636 7.32728 4.66441 8.31575 4.6683C8.72019 4.66976 8.983 4.92041 8.98056 5.28299C8.97813 5.64265 8.71045 5.88016 8.30261 5.88113C7.81105 5.88259 7.31998 5.88113 6.82843 5.88113L6.82891 5.88211Z"
                      fill="#082F21"
                    />
                  </svg>

                  Hired</router-link
                >
                 <router-link v-if="userProfile?.is_insurance"
                  class="mobile-link has-icon"
                  to="/careseeker/staff"
                  @click="toggleMobileMenu"
                >
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7645 7.13988C16.767 7.88014 16.7601 8.62039 16.7412 9.36065C16.6871 11.4914 14.9901 13.3632 12.8725 13.5983C12.0923 13.6849 11.3082 13.6333 10.5256 13.645C9.90317 13.6542 9.30552 13.7691 8.76627 14.0961C8.51757 14.247 8.2825 14.4208 8.04499 14.5892C7.51012 14.9683 6.98109 15.3552 6.44378 15.7304C5.58429 16.3305 4.41235 15.8803 4.17387 14.8583C4.11206 14.594 4.1359 14.3288 4.22059 14.0684C4.3116 13.7895 4.20891 13.643 3.91397 13.6474C3.39565 13.6547 2.88025 13.6469 2.38869 13.4566C1.00065 12.9188 0.204429 11.9177 0.0272742 10.4314C0.00147971 10.2133 0.00245261 9.99529 0.00245261 9.77726C0.0029393 8.38094 -0.00728053 6.98463 0.010727 5.58881C0.0199741 4.86267 0.0311672 4.13409 0.174254 3.41525C0.497416 1.78971 1.96089 0.389017 3.59665 0.141779C4.42792 0.0162131 5.26502 0.0113463 6.10164 0.00696609C7.789 -0.00179432 9.47684 -0.00471451 11.1642 0.0128063C11.8903 0.0201066 12.6184 0.0327606 13.3382 0.17244C14.9711 0.490249 16.381 1.95762 16.6312 3.59727C16.7334 4.26598 16.7392 4.93859 16.7611 5.61071C16.7777 6.12027 16.7645 6.63032 16.7645 7.14037V7.13988ZM8.392 1.22174V1.21931C7.63326 1.21931 6.87402 1.21931 6.11527 1.21931C5.35701 1.2198 4.59875 1.22515 3.84438 1.32638C2.73667 1.47482 1.68494 2.40099 1.40022 3.4829C1.2474 4.06401 1.2328 4.66118 1.22648 5.25348C1.20993 6.88681 1.21626 8.52014 1.21966 10.153C1.2221 11.1585 1.91758 12.0681 2.88317 12.3499C3.24964 12.457 3.62585 12.454 4.00207 12.455C4.99734 12.4575 5.68406 13.3758 5.40762 14.3302C5.38913 14.394 5.36771 14.4592 5.36382 14.5249C5.35263 14.7308 5.53465 14.8495 5.72008 14.7561C5.79551 14.7181 5.86365 14.6651 5.93276 14.6159C6.55524 14.1716 7.17479 13.7228 7.80067 13.2829C8.56088 12.749 9.40334 12.455 10.3378 12.455C11.0177 12.455 11.6971 12.4424 12.377 12.4244C13.7505 12.3883 14.9351 11.5191 15.3779 10.2206C15.522 9.79867 15.5415 9.36211 15.5458 8.92701C15.5585 7.75555 15.558 6.58311 15.5468 5.41165C15.542 4.89089 15.5181 4.36965 15.4471 3.85133C15.2933 2.73145 14.372 1.6841 13.2769 1.3989C12.6895 1.24559 12.0865 1.2378 11.4878 1.2271C10.4561 1.2086 9.42378 1.22223 8.39152 1.22223L8.392 1.22174Z"
                      fill="#082F21"
                    />
                    <path
                      d="M8.37954 8.98194C7.34143 8.98194 6.30332 8.98341 5.26521 8.98097C5.00386 8.98048 4.79653 8.82718 4.7099 8.58627C4.62667 8.35509 4.69919 8.08595 4.88949 7.9268C5.00094 7.83336 5.12894 7.79102 5.27543 7.79102C7.34581 7.79199 9.4157 7.79102 11.4861 7.79248C11.8306 7.79248 12.0964 8.05383 12.0998 8.38283C12.1032 8.71621 11.8316 8.98097 11.4759 8.98146C10.4436 8.9834 9.4118 8.98243 8.37954 8.98146V8.98194Z"
                      fill="#082F21"
                    />
                    <path
                      d="M6.82891 5.88211C6.31935 5.88211 5.80978 5.88551 5.30022 5.88065C5.01259 5.87821 4.78044 5.7069 4.70403 5.45771C4.62518 5.20074 4.71425 4.94231 4.93569 4.78316C5.0598 4.69458 5.20191 4.6683 5.34938 4.66782C6.33833 4.66636 7.32728 4.66441 8.31575 4.6683C8.72019 4.66976 8.983 4.92041 8.98056 5.28299C8.97813 5.64265 8.71045 5.88016 8.30261 5.88113C7.81105 5.88259 7.31998 5.88113 6.82843 5.88113L6.82891 5.88211Z"
                      fill="#082F21"
                    />
                  </svg>

                  Staff</router-link
                >
              </div>
              <div
                @click="toggleAccountDropdown"
                style="
                  padding: 10px;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <span> Account </span>
                <span
                  class="dropdown-arrow"
                  :class="{ open: isAccountDropdownOpen }"
                  ><svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1.70492L10.59 0.294922L6 4.87492L1.41 0.294921L-6.16331e-08 1.70492L6 7.70492L12 1.70492Z"
                      fill="black"
                    />
                  </svg>
                </span>
              </div>
              <div v-if="isAccountDropdownOpen">
                <router-link
                  class="mobile-link has-icon"
                  :to="
                    careType == 'Care seeker'
                      ? '/careseeker/profile'
                      : '/caregiver/profile'
                  "
                >
                  <!-- <svg
                  width="19"
                  height="16"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.1077 4.11247V7.29252C18.0109 7.70601 17.8443 8.08647 17.5573 8.40367C17.4511 8.52073 17.4114 8.64393 17.4119 8.80159C17.4162 10.6444 17.4152 12.4876 17.4143 14.3304C17.4138 15.3099 16.7275 15.9953 15.7438 15.9953C11.2921 15.9962 6.84087 15.9901 2.38919 16C1.36536 16.0024 0.689422 15.1692 0.701694 14.3205C0.7286 12.4777 0.708303 10.6345 0.712551 8.79167C0.712551 8.64063 0.671485 8.52451 0.572359 8.40981C0.189545 7.96563 -0.00823382 7.45395 0.000262663 6.85778C0.0125354 6.03929 0.0045109 5.22079 0.00309482 4.4023C0.0026228 4.0209 0.129126 3.68671 0.370332 3.39547C0.722935 2.9697 1.19166 2.80402 1.73071 2.80307C2.54921 2.80213 3.3677 2.80307 4.18619 2.80213C4.4071 2.80213 4.41938 2.78891 4.41985 2.57461C4.42079 2.2744 4.4189 1.97419 4.42079 1.67351C4.42646 0.762973 5.15668 0.00914686 6.06533 0.00584267C8.06153 -0.00218178 10.0577 -0.00170976 12.0535 0.00584267C12.964 0.00914686 13.6971 0.759669 13.7037 1.66879C13.7056 1.96334 13.7037 2.25741 13.7046 2.55195C13.7046 2.79458 13.7117 2.8026 13.9505 2.8026C14.7516 2.80354 15.5521 2.80166 16.3532 2.80354C16.5948 2.80402 16.836 2.82243 17.0654 2.90928C17.629 3.12263 17.9566 3.54132 18.1077 4.11247ZM9.0561 3.91234C6.60722 3.91234 4.15787 3.91234 1.709 3.91234C1.29362 3.91234 1.09253 4.11389 1.09159 4.53163C1.0897 5.29679 1.09112 6.06242 1.09159 6.82757C1.09159 7.17215 1.20723 7.47236 1.439 7.7282C1.59005 7.8953 1.76092 8.03832 1.94784 8.16294C2.59877 8.59673 3.32663 8.84596 4.07338 9.04799C5.00752 9.30052 5.96102 9.43741 6.92253 9.52898C7.19348 9.55494 7.21094 9.54833 7.21283 9.27031C7.21377 9.12398 7.19489 8.97529 7.269 8.83793C7.4007 8.59342 7.62208 8.52687 7.87792 8.52687C8.66667 8.52687 9.4559 8.52592 10.2447 8.52781C10.3263 8.52781 10.4099 8.53678 10.4896 8.55377C10.7327 8.60617 10.8994 8.80631 10.9121 9.05459C10.9164 9.13673 10.9135 9.21933 10.914 9.30194C10.9149 9.53984 10.9409 9.56202 11.183 9.53323C11.5569 9.48886 11.9312 9.45204 12.3036 9.39917C13.3081 9.25568 14.2956 9.04279 15.2387 8.65668C15.7258 8.45748 16.1889 8.21533 16.575 7.84762C16.8861 7.55166 17.0414 7.19575 17.0366 6.76196C17.0286 6.03221 17.0348 5.30198 17.0343 4.57176C17.0343 4.09737 16.8464 3.91186 16.3683 3.91186C13.9312 3.91186 11.4936 3.91186 9.05657 3.91186L9.0561 3.91234ZM9.06318 14.8865C11.2826 14.8865 13.5026 14.887 15.7221 14.886C16.1247 14.886 16.3258 14.6925 16.3267 14.2965C16.3296 12.7128 16.3267 11.1292 16.33 9.54503C16.33 9.39304 16.2946 9.37416 16.1615 9.4426C15.562 9.75083 14.9248 9.96089 14.2739 10.1285C13.2689 10.3871 12.2479 10.5519 11.2133 10.6264C11.0051 10.6415 10.8323 10.6784 10.7998 10.9314C10.7903 11.0036 10.7445 11.0735 10.7068 11.1395C10.2904 11.8693 9.63716 12.1435 8.83235 12.0642C8.079 11.9897 7.55835 11.5776 7.3011 10.8601C7.24965 10.7161 7.1812 10.651 7.03204 10.6392C6.48119 10.5948 5.93222 10.5311 5.38561 10.4471C4.21121 10.2668 3.06844 9.97646 1.99363 9.45487C1.86367 9.39194 1.79853 9.43379 1.79821 9.58043C1.79821 11.123 1.79821 12.6656 1.79821 14.2082C1.79821 14.717 1.96673 14.8855 2.47557 14.8855C4.67144 14.8855 6.86778 14.8855 9.06365 14.8855L9.06318 14.8865ZM9.06223 2.8026C9.23263 2.8026 9.40351 2.8026 9.57391 2.8026C10.5095 2.8026 11.4445 2.8026 12.3801 2.8026C12.6067 2.8026 12.6171 2.7908 12.6175 2.56092C12.618 2.29612 12.6208 2.03131 12.6166 1.76697C12.6095 1.34357 12.3796 1.11322 11.9572 1.11322C10.0275 1.11133 8.09788 1.11133 6.16824 1.11322C5.74436 1.11322 5.51542 1.34262 5.50881 1.7665C5.50457 2.02517 5.5074 2.28432 5.50787 2.54299C5.50787 2.79599 5.51353 2.80307 5.76229 2.80307C6.86259 2.80354 7.96241 2.80307 9.0627 2.80307L9.06223 2.8026ZM8.29849 10.0931C8.29047 10.3163 8.30132 10.583 8.52176 10.7926C8.70208 10.9644 8.92157 10.971 9.14814 10.9635C9.50546 10.9517 9.74101 10.7511 9.80898 10.3985C9.8458 10.2063 9.81606 10.0114 9.82786 9.81786C9.83635 9.6772 9.77263 9.63235 9.63905 9.63472C9.32751 9.64038 9.01597 9.63472 8.70443 9.6366C8.24798 9.63896 8.30321 9.58846 8.29896 10.0931H8.29849Z"
                    fill="#082F21"
                  />
                </svg> -->

                  Profile</router-link
                >
                <router-link
                  class="mobile-link has-icon"
                  :to="
                    careType == 'Care seeker'
                      ? '/careseeker/account-privacy'
                      : '/caregiver/account-privacy'
                  "
                >
                  <!-- <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7645 7.13988C16.767 7.88014 16.7601 8.62039 16.7412 9.36065C16.6871 11.4914 14.9901 13.3632 12.8725 13.5983C12.0923 13.6849 11.3082 13.6333 10.5256 13.645C9.90317 13.6542 9.30552 13.7691 8.76627 14.0961C8.51757 14.247 8.2825 14.4208 8.04499 14.5892C7.51012 14.9683 6.98109 15.3552 6.44378 15.7304C5.58429 16.3305 4.41235 15.8803 4.17387 14.8583C4.11206 14.594 4.1359 14.3288 4.22059 14.0684C4.3116 13.7895 4.20891 13.643 3.91397 13.6474C3.39565 13.6547 2.88025 13.6469 2.38869 13.4566C1.00065 12.9188 0.204429 11.9177 0.0272742 10.4314C0.00147971 10.2133 0.00245261 9.99529 0.00245261 9.77726C0.0029393 8.38094 -0.00728053 6.98463 0.010727 5.58881C0.0199741 4.86267 0.0311672 4.13409 0.174254 3.41525C0.497416 1.78971 1.96089 0.389017 3.59665 0.141779C4.42792 0.0162131 5.26502 0.0113463 6.10164 0.00696609C7.789 -0.00179432 9.47684 -0.00471451 11.1642 0.0128063C11.8903 0.0201066 12.6184 0.0327606 13.3382 0.17244C14.9711 0.490249 16.381 1.95762 16.6312 3.59727C16.7334 4.26598 16.7392 4.93859 16.7611 5.61071C16.7777 6.12027 16.7645 6.63032 16.7645 7.14037V7.13988ZM8.392 1.22174V1.21931C7.63326 1.21931 6.87402 1.21931 6.11527 1.21931C5.35701 1.2198 4.59875 1.22515 3.84438 1.32638C2.73667 1.47482 1.68494 2.40099 1.40022 3.4829C1.2474 4.06401 1.2328 4.66118 1.22648 5.25348C1.20993 6.88681 1.21626 8.52014 1.21966 10.153C1.2221 11.1585 1.91758 12.0681 2.88317 12.3499C3.24964 12.457 3.62585 12.454 4.00207 12.455C4.99734 12.4575 5.68406 13.3758 5.40762 14.3302C5.38913 14.394 5.36771 14.4592 5.36382 14.5249C5.35263 14.7308 5.53465 14.8495 5.72008 14.7561C5.79551 14.7181 5.86365 14.6651 5.93276 14.6159C6.55524 14.1716 7.17479 13.7228 7.80067 13.2829C8.56088 12.749 9.40334 12.455 10.3378 12.455C11.0177 12.455 11.6971 12.4424 12.377 12.4244C13.7505 12.3883 14.9351 11.5191 15.3779 10.2206C15.522 9.79867 15.5415 9.36211 15.5458 8.92701C15.5585 7.75555 15.558 6.58311 15.5468 5.41165C15.542 4.89089 15.5181 4.36965 15.4471 3.85133C15.2933 2.73145 14.372 1.6841 13.2769 1.3989C12.6895 1.24559 12.0865 1.2378 11.4878 1.2271C10.4561 1.2086 9.42378 1.22223 8.39152 1.22223L8.392 1.22174Z"
                    fill="#082F21"
                  />
                  <path
                    d="M8.37954 8.98194C7.34143 8.98194 6.30332 8.98341 5.26521 8.98097C5.00386 8.98048 4.79653 8.82718 4.7099 8.58627C4.62667 8.35509 4.69919 8.08595 4.88949 7.9268C5.00094 7.83336 5.12894 7.79102 5.27543 7.79102C7.34581 7.79199 9.4157 7.79102 11.4861 7.79248C11.8306 7.79248 12.0964 8.05383 12.0998 8.38283C12.1032 8.71621 11.8316 8.98097 11.4759 8.98146C10.4436 8.9834 9.4118 8.98243 8.37954 8.98146V8.98194Z"
                    fill="#082F21"
                  />
                  <path
                    d="M6.82891 5.88211C6.31935 5.88211 5.80978 5.88551 5.30022 5.88065C5.01259 5.87821 4.78044 5.7069 4.70403 5.45771C4.62518 5.20074 4.71425 4.94231 4.93569 4.78316C5.0598 4.69458 5.20191 4.6683 5.34938 4.66782C6.33833 4.66636 7.32728 4.66441 8.31575 4.6683C8.72019 4.66976 8.983 4.92041 8.98056 5.28299C8.97813 5.64265 8.71045 5.88016 8.30261 5.88113C7.81105 5.88259 7.31998 5.88113 6.82843 5.88113L6.82891 5.88211Z"
                    fill="#082F21"
                  />
                </svg> -->

                  Account & Privacy</router-link
                >
              </div>
              <router-link
                class="mobile-link"
                v-if="
                  careType == 'Care seeker' &&
                  !userProfile?.care_seeker?.has_access
                "
                to="/admin"
                @click="toggleMobileMenu"
                >Upgrade</router-link
              >
            </div>
            <!-- <router-link
              class="mobile-link upgrade-mobile"
              v-else
              to="/admin"
          
              >Upgrade</router-link
            > -->
            <div class="mobile-link has-icon" @click="logout">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.77778 16C1.28889 16 0.870222 15.8261 0.521778 15.4782C0.173926 15.1298 0 14.7111 0 14.2222V1.77778C0 1.28889 0.173926 0.870222 0.521778 0.521778C0.870222 0.173926 1.28889 0 1.77778 0H8V1.77778H1.77778V14.2222H8V16H1.77778ZM11.5556 12.4444L10.3333 11.1556L12.6 8.88889H5.33333V7.11111H12.6L10.3333 4.84444L11.5556 3.55556L16 8L11.5556 12.4444Z"
                  fill="black"
                />
              </svg>

              Logout
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 16px">
            <div class="menu-icon" @click="toggleMobileMenu">
              <svg
                width="18"
                height="12"
                viewBox="0 0 18 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 12V10H18V12H0ZM0 7V5H18V7H0ZM0 2V0H18V2H0Z"
                  fill="black"
                />
              </svg>
            </div>
            <img
              @click="redirectToHome"
              class="main-logo"
              src="@/assets/full_logo.svg"
              alt="Logo"
            />
          </div>

          <div class="links">
            <router-link
              v-if="!userProfile?.is_insurance"
              class="normal-links"
              :to="
                careType == 'Care seeker'
                  ? '/careseeker/my-jobs'
                  : '/caregiver/my-jobs'
              "
              active-class="active-link"
            >
              <svg
                width="23"
                height="21"
                viewBox="0 0 23 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.8173 5.64059V9.61565C22.6963 10.1325 22.4881 10.6081 22.1293 11.0046C21.9966 11.1509 21.947 11.3049 21.9476 11.502C21.9529 13.8055 21.9517 16.1096 21.9505 18.413C21.95 19.6374 21.092 20.4941 19.8624 20.4941C14.2978 20.4953 8.73379 20.4876 3.16919 20.5C1.88941 20.5029 1.04448 19.4615 1.05982 18.4007C1.09345 16.0972 1.06808 13.7931 1.07339 11.4896C1.07339 11.3008 1.02206 11.1556 0.89815 11.0123C0.419633 10.457 0.172409 9.81744 0.183029 9.07223C0.19837 8.04911 0.18834 7.02599 0.18657 6.00287C0.18598 5.52613 0.344109 5.10838 0.645616 4.74433C1.08637 4.21212 1.67227 4.00502 2.34609 4.00384C3.36921 4.00266 4.39233 4.00384 5.41544 4.00266C5.69158 4.00266 5.70692 3.98614 5.70751 3.71826C5.70869 3.343 5.70633 2.96774 5.70869 2.59189C5.71577 1.45372 6.62855 0.511434 7.76437 0.507303C10.2596 0.497273 12.7549 0.497863 15.2495 0.507303C16.3877 0.511434 17.304 1.44959 17.3123 2.58599C17.3146 2.95417 17.3123 3.32176 17.3135 3.68994C17.3135 3.99322 17.3223 4.00325 17.6209 4.00325C18.6222 4.00443 19.6229 4.00207 20.6241 4.00443C20.9262 4.00502 21.2277 4.02803 21.5145 4.1366C22.219 4.40329 22.6285 4.92665 22.8173 5.64059ZM11.5028 5.39042C8.44173 5.39042 5.38004 5.39042 2.31895 5.39042C1.79972 5.39042 1.54837 5.64236 1.54719 6.16454C1.54483 7.12099 1.5466 8.07802 1.54719 9.03446C1.54719 9.46519 1.69174 9.84045 1.98145 10.1602C2.17026 10.3691 2.38385 10.5479 2.61751 10.7037C3.43116 11.2459 4.34099 11.5574 5.27443 11.81C6.4421 12.1257 7.63397 12.2968 8.83587 12.4112C9.17455 12.4437 9.19638 12.4354 9.19874 12.0879C9.19992 11.905 9.17632 11.7191 9.26895 11.5474C9.43357 11.2418 9.7103 11.1586 10.0301 11.1586C11.016 11.1586 12.0026 11.1574 12.9885 11.1598C13.0906 11.1598 13.195 11.171 13.2948 11.1922C13.5986 11.2577 13.8069 11.5079 13.8228 11.8182C13.8281 11.9209 13.8246 12.0242 13.8252 12.1274C13.8264 12.4248 13.8588 12.4525 14.1615 12.4165C14.6288 12.3611 15.0967 12.3151 15.5622 12.249C16.8178 12.0696 18.0522 11.8035 19.2311 11.3208C19.84 11.0718 20.4188 10.7692 20.9015 10.3095C21.2903 9.93958 21.4844 9.49469 21.4785 8.95245C21.4685 8.04026 21.4762 7.12748 21.4756 6.2147C21.4756 5.62171 21.2407 5.38983 20.643 5.38983C17.5967 5.38983 14.5498 5.38983 11.5034 5.38983L11.5028 5.39042ZM11.5117 19.1081C14.286 19.1081 17.0609 19.1087 19.8353 19.1075C20.3386 19.1075 20.5899 18.8656 20.5911 18.3706C20.5946 16.391 20.5911 14.4114 20.5952 12.4313C20.5952 12.2413 20.551 12.2177 20.3846 12.3033C19.6352 12.6885 18.8387 12.9511 18.025 13.1606C16.7689 13.4839 15.4926 13.6898 14.1993 13.7831C13.9391 13.8019 13.7231 13.848 13.6824 14.1642C13.6706 14.2545 13.6134 14.3418 13.5662 14.4244C13.0458 15.3366 12.2292 15.6794 11.2231 15.5803C10.2815 15.4871 9.63064 14.972 9.30908 14.0751C9.24476 13.8952 9.15921 13.8137 8.97276 13.799C8.28419 13.7435 7.59798 13.6639 6.91472 13.5588C5.44672 13.3334 4.01825 12.9706 2.67474 12.3186C2.51228 12.2399 2.43086 12.2922 2.43047 12.4755C2.43047 14.4038 2.43047 16.332 2.43047 18.2602C2.43047 18.8963 2.64111 19.1069 3.27716 19.1069C6.022 19.1069 8.76742 19.1069 11.5123 19.1069L11.5117 19.1081ZM11.5105 4.00325C11.7235 4.00325 11.9371 4.00325 12.1501 4.00325C13.3195 4.00325 14.4884 4.00325 15.6578 4.00325C15.941 4.00325 15.954 3.9885 15.9546 3.70115C15.9552 3.37015 15.9587 3.03914 15.9534 2.70872C15.9446 2.17946 15.6572 1.89152 15.1292 1.89152C12.7171 1.88916 10.3051 1.88916 7.893 1.89152C7.36315 1.89152 7.07698 2.17828 7.06872 2.70813C7.06341 3.03147 7.06695 3.35539 7.06754 3.67873C7.06754 3.99499 7.07462 4.00384 7.38557 4.00384C8.76093 4.00443 10.1357 4.00384 11.5111 4.00384L11.5105 4.00325ZM10.5558 13.1163C10.5458 13.3954 10.5594 13.7288 10.8349 13.9907C11.0603 14.2055 11.3347 14.2138 11.6179 14.2043C12.0645 14.1896 12.359 13.9388 12.4439 13.4981C12.4899 13.2579 12.4528 13.0142 12.4675 12.7723C12.4781 12.5965 12.3985 12.5404 12.2315 12.5434C11.8421 12.5505 11.4527 12.5434 11.0632 12.5458C10.4927 12.5487 10.5617 12.4856 10.5564 13.1163H10.5558Z"
                  fill="#082F21"
                />
              </svg>
              Jobs
            </router-link>
            <router-link
              v-if="careType == 'Care seeker' && userProfile?.is_insurance"
              class="normal-links"
              to="/careseeker/staff"
              active-class="active-link"
            >
              <svg
                width="23"
                height="21"
                viewBox="0 0 23 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.8173 5.64059V9.61565C22.6963 10.1325 22.4881 10.6081 22.1293 11.0046C21.9966 11.1509 21.947 11.3049 21.9476 11.502C21.9529 13.8055 21.9517 16.1096 21.9505 18.413C21.95 19.6374 21.092 20.4941 19.8624 20.4941C14.2978 20.4953 8.73379 20.4876 3.16919 20.5C1.88941 20.5029 1.04448 19.4615 1.05982 18.4007C1.09345 16.0972 1.06808 13.7931 1.07339 11.4896C1.07339 11.3008 1.02206 11.1556 0.89815 11.0123C0.419633 10.457 0.172409 9.81744 0.183029 9.07223C0.19837 8.04911 0.18834 7.02599 0.18657 6.00287C0.18598 5.52613 0.344109 5.10838 0.645616 4.74433C1.08637 4.21212 1.67227 4.00502 2.34609 4.00384C3.36921 4.00266 4.39233 4.00384 5.41544 4.00266C5.69158 4.00266 5.70692 3.98614 5.70751 3.71826C5.70869 3.343 5.70633 2.96774 5.70869 2.59189C5.71577 1.45372 6.62855 0.511434 7.76437 0.507303C10.2596 0.497273 12.7549 0.497863 15.2495 0.507303C16.3877 0.511434 17.304 1.44959 17.3123 2.58599C17.3146 2.95417 17.3123 3.32176 17.3135 3.68994C17.3135 3.99322 17.3223 4.00325 17.6209 4.00325C18.6222 4.00443 19.6229 4.00207 20.6241 4.00443C20.9262 4.00502 21.2277 4.02803 21.5145 4.1366C22.219 4.40329 22.6285 4.92665 22.8173 5.64059ZM11.5028 5.39042C8.44173 5.39042 5.38004 5.39042 2.31895 5.39042C1.79972 5.39042 1.54837 5.64236 1.54719 6.16454C1.54483 7.12099 1.5466 8.07802 1.54719 9.03446C1.54719 9.46519 1.69174 9.84045 1.98145 10.1602C2.17026 10.3691 2.38385 10.5479 2.61751 10.7037C3.43116 11.2459 4.34099 11.5574 5.27443 11.81C6.4421 12.1257 7.63397 12.2968 8.83587 12.4112C9.17455 12.4437 9.19638 12.4354 9.19874 12.0879C9.19992 11.905 9.17632 11.7191 9.26895 11.5474C9.43357 11.2418 9.7103 11.1586 10.0301 11.1586C11.016 11.1586 12.0026 11.1574 12.9885 11.1598C13.0906 11.1598 13.195 11.171 13.2948 11.1922C13.5986 11.2577 13.8069 11.5079 13.8228 11.8182C13.8281 11.9209 13.8246 12.0242 13.8252 12.1274C13.8264 12.4248 13.8588 12.4525 14.1615 12.4165C14.6288 12.3611 15.0967 12.3151 15.5622 12.249C16.8178 12.0696 18.0522 11.8035 19.2311 11.3208C19.84 11.0718 20.4188 10.7692 20.9015 10.3095C21.2903 9.93958 21.4844 9.49469 21.4785 8.95245C21.4685 8.04026 21.4762 7.12748 21.4756 6.2147C21.4756 5.62171 21.2407 5.38983 20.643 5.38983C17.5967 5.38983 14.5498 5.38983 11.5034 5.38983L11.5028 5.39042ZM11.5117 19.1081C14.286 19.1081 17.0609 19.1087 19.8353 19.1075C20.3386 19.1075 20.5899 18.8656 20.5911 18.3706C20.5946 16.391 20.5911 14.4114 20.5952 12.4313C20.5952 12.2413 20.551 12.2177 20.3846 12.3033C19.6352 12.6885 18.8387 12.9511 18.025 13.1606C16.7689 13.4839 15.4926 13.6898 14.1993 13.7831C13.9391 13.8019 13.7231 13.848 13.6824 14.1642C13.6706 14.2545 13.6134 14.3418 13.5662 14.4244C13.0458 15.3366 12.2292 15.6794 11.2231 15.5803C10.2815 15.4871 9.63064 14.972 9.30908 14.0751C9.24476 13.8952 9.15921 13.8137 8.97276 13.799C8.28419 13.7435 7.59798 13.6639 6.91472 13.5588C5.44672 13.3334 4.01825 12.9706 2.67474 12.3186C2.51228 12.2399 2.43086 12.2922 2.43047 12.4755C2.43047 14.4038 2.43047 16.332 2.43047 18.2602C2.43047 18.8963 2.64111 19.1069 3.27716 19.1069C6.022 19.1069 8.76742 19.1069 11.5123 19.1069L11.5117 19.1081ZM11.5105 4.00325C11.7235 4.00325 11.9371 4.00325 12.1501 4.00325C13.3195 4.00325 14.4884 4.00325 15.6578 4.00325C15.941 4.00325 15.954 3.9885 15.9546 3.70115C15.9552 3.37015 15.9587 3.03914 15.9534 2.70872C15.9446 2.17946 15.6572 1.89152 15.1292 1.89152C12.7171 1.88916 10.3051 1.88916 7.893 1.89152C7.36315 1.89152 7.07698 2.17828 7.06872 2.70813C7.06341 3.03147 7.06695 3.35539 7.06754 3.67873C7.06754 3.99499 7.07462 4.00384 7.38557 4.00384C8.76093 4.00443 10.1357 4.00384 11.5111 4.00384L11.5105 4.00325ZM10.5558 13.1163C10.5458 13.3954 10.5594 13.7288 10.8349 13.9907C11.0603 14.2055 11.3347 14.2138 11.6179 14.2043C12.0645 14.1896 12.359 13.9388 12.4439 13.4981C12.4899 13.2579 12.4528 13.0142 12.4675 12.7723C12.4781 12.5965 12.3985 12.5404 12.2315 12.5434C11.8421 12.5505 11.4527 12.5434 11.0632 12.5458C10.4927 12.5487 10.5617 12.4856 10.5564 13.1163H10.5558Z"
                  fill="#082F21"
                />
              </svg>
              Staff
            </router-link>
            <router-link
              v-if="!userProfile?.is_insurance"
              class="normal-links"
              to="/messages"
              active-class="active-link"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.9747 9.42486C20.9778 10.3502 20.9693 11.2755 20.9455 12.2008C20.878 14.8642 18.7566 17.204 16.1097 17.4978C15.1345 17.6061 14.1544 17.5416 13.1761 17.5562C12.398 17.5678 11.651 17.7114 10.9769 18.1202C10.666 18.3088 10.3722 18.5259 10.0753 18.7364C9.40673 19.2104 8.74544 19.694 8.07381 20.163C6.99945 20.9132 5.53451 20.3504 5.23642 19.0729C5.15915 18.7425 5.18896 18.411 5.29482 18.0855C5.40858 17.7369 5.28022 17.5538 4.91155 17.5593C4.26364 17.5684 3.61939 17.5587 3.00495 17.3208C1.2699 16.6485 0.274618 15.3971 0.0531739 13.5392C0.0209307 13.2667 0.0221469 12.9941 0.0221469 12.7216C0.0227552 10.9762 0.00998046 9.23079 0.0324898 7.48601C0.0440487 6.57833 0.0580401 5.66761 0.236898 4.76906C0.640851 2.73714 2.47019 0.986271 4.5149 0.677224C5.55398 0.520266 6.60036 0.514183 7.64614 0.508708C9.75533 0.497757 11.8651 0.494107 13.9743 0.516008C14.882 0.525133 15.7921 0.540951 16.6919 0.715551C18.7329 1.11281 20.4953 2.94702 20.808 4.99659C20.9358 5.83248 20.9431 6.67324 20.9705 7.51338C20.9912 8.15034 20.9747 8.7879 20.9747 9.42546V9.42486ZM10.5091 2.02718V2.02414C9.56065 2.02414 8.6116 2.02414 7.66317 2.02414C6.71534 2.02474 5.76751 2.03144 4.82455 2.15798C3.43992 2.34353 2.12525 3.50124 1.76936 4.85363C1.57833 5.58001 1.56009 6.32647 1.55218 7.06685C1.53149 9.10851 1.5394 11.1502 1.54366 13.1912C1.5467 14.4481 2.41605 15.5851 3.62304 15.9374C4.08114 16.0712 4.5514 16.0676 5.02166 16.0688C6.26576 16.0718 7.12416 17.2198 6.77861 18.4128C6.75549 18.4925 6.72872 18.574 6.72386 18.6561C6.70987 18.9135 6.93739 19.0619 7.16918 18.9451C7.26347 18.8977 7.34864 18.8313 7.43503 18.7699C8.21313 18.2145 8.98757 17.6536 9.76993 17.1036C10.7202 16.4362 11.7733 16.0688 12.9413 16.0688C13.7912 16.0688 14.6405 16.053 15.4904 16.0304C17.2071 15.9854 18.6879 14.8989 19.2415 13.2758C19.4216 12.7483 19.4459 12.2026 19.4514 11.6588C19.4672 10.1944 19.4666 8.72889 19.4526 7.26456C19.4465 6.61362 19.4167 5.96206 19.3279 5.31416C19.1357 3.91432 17.984 2.60512 16.6152 2.24862C15.8809 2.05699 15.1272 2.04725 14.3789 2.03387C13.0891 2.01075 11.7988 2.02779 10.5085 2.02779L10.5091 2.02718Z"
                  fill="#082F21"
                />
                <path
                  d="M10.4945 11.7269C9.19684 11.7269 7.89921 11.7288 6.60157 11.7257C6.27488 11.7251 6.01572 11.5335 5.90743 11.2323C5.8034 10.9434 5.89405 10.6069 6.13192 10.408C6.27123 10.2912 6.43123 10.2383 6.61435 10.2383C9.20232 10.2395 11.7897 10.2383 14.3776 10.2401C14.8084 10.2401 15.1405 10.5668 15.1448 10.978C15.1491 11.3948 14.8096 11.7257 14.3649 11.7263C13.0745 11.7288 11.7848 11.7276 10.4945 11.7263V11.7269Z"
                  fill="#082F21"
                />
                <path
                  d="M8.55425 7.85214C7.91729 7.85214 7.28033 7.8564 6.64338 7.85032C6.28384 7.84728 5.99365 7.63313 5.89814 7.32165C5.79958 7.00044 5.91091 6.6774 6.18772 6.47846C6.34285 6.36774 6.52049 6.33489 6.70482 6.33428C7.94102 6.33246 9.17721 6.33002 10.4128 6.33489C10.9183 6.33671 11.2469 6.65002 11.2438 7.10325C11.2408 7.55283 10.9062 7.84971 10.3964 7.85093C9.78192 7.85275 9.16808 7.85093 8.55364 7.85093L8.55425 7.85214Z"
                  fill="#082F21"
                />
              </svg>
              Messages
            </router-link>
            <div v-if="isLargeScreen" class="profile-dropdown">
              <button @click="toggleDropdown" class="profile-button">
                <span class="profile-initials"
                  >{{ userProfile.first_name.charAt(0)
                  }}{{ userProfile.last_name.charAt(0) }}</span
                >
                <span class="dropdown-arrow" :class="{ open: isDropdownOpen }"
                  ><svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1.70492L10.59 0.294922L6 4.87492L1.41 0.294921L-6.16331e-08 1.70492L6 7.70492L12 1.70492Z"
                      fill="black"
                    />
                  </svg>
                </span>
              </button>
              <div v-if="isDropdownOpen" class="dropdown-menu">
                <div class="dropdown-header">
                  <span class="profile-initials"
                    >{{ userProfile.first_name.charAt(0)
                    }}{{ userProfile.last_name.charAt(0) }}</span
                  >
                  <p>
                    {{ userProfile.first_name }} {{ userProfile.last_name }}
                  </p>
                </div>
                <div class="dropdown-section">
                  <p class="dropdown-title">Manage</p>
                  <ul>
                    <li v-if="!userProfile?.is_insurance">
                      <router-link
                        to="/messages"
                        >Messages</router-link
                      >
                    </li>
                    <li v-if="!userProfile?.is_insurance">
                      <router-link
                        :to="
                          careType == 'Care seeker'
                            ? '/careseeker/my-jobs'
                            : '/caregiver/my-jobs'
                        "
                        >Jobs</router-link
                      >
                    </li>
                    <li
                      v-if="
                        careType == 'Care seeker' && !userProfile?.is_insurance
                      "
                    >
                      <router-link to="/careseeker/hired">Hired</router-link>
                    </li>
                    <li
                      v-if="
                        careType == 'Care seeker' && userProfile?.is_insurance
                      "
                    >
                      <router-link to="/careseeker/staff"
                        >Manage your Staff</router-link
                      >
                    </li>
                  </ul>
                </div>
                <div class="dropdown-section">
                  <p class="dropdown-title">Account</p>
                  <ul>
                    <li>
                      <router-link
                        :to="
                          careType == 'Care seeker'
                            ? '/careseeker/profile'
                            : '/caregiver/profile'
                        "
                        >Profile</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="
                          careType == 'Care seeker'
                            ? '/careseeker/account-privacy'
                            : '/caregiver/account-privacy'
                        "
                        >Account & Privacy</router-link
                      >
                    </li>
                  </ul>
                </div>
                <div class="dropdown-section">
                  <p class="dropdown-title">Resources</p>
                  <ul>
                    <li>Safety</li>
                    <li>Articles & Guides</li>
                    <li>Help</li>
                  </ul>
                </div>
                <div class="dropdown-footer">
                  <BaseButton
                    label="Log Out"
                    backgroundColor="transparent"
                    textColor="var(--s-green-normal-active)"
                    height="60px"
                    width="100%"
                    borderColor="var(--s-green-normal-active)"
                    @click="logout"
                  />
                </div>
              </div>
            </div>

            <router-link
              v-if="
                careType == 'Care seeker' &&
                !userProfile?.care_seeker?.has_access
              "
              class="join-now"
              to="/admin"
              >Upgrade</router-link
            >
            <router-link
              v-else-if="careType == 'Care giver'"
              class="join-now-graded"
              >Upgrade</router-link
            >
          </div>
        </nav>
      </div>
      <div class="main-one">
        <!-- <div class="dashboard-container"></div> -->
        <slot></slot>
      </div>
    </div>
    <footer>
      <div class="footer">
        <div class="footer-content-container">
          <div v-if="isLargeScreen" class="logoandsocialmedia">
            <img
              src="@/assets/white_logo.svg"
              style="width: 167.32px; height: 60.05px; margin-bottom: 16px"
              alt="Logo"
            />
            <div style="margin-bottom: 61px">
              <p class="white-text">
                Succour helps families and individuals connect with trusted,
                verified caregivers
              </p>
            </div>
            <div class="social-media-links">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                class="clickable-div"
              >
                <img src="@/assets/linkedin.svg" />
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                class="clickable-div"
              >
                <img src="@/assets/facebook.svg" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                class="clickable-div"
              >
                <img src="@/assets/instagram.svg" />
              </a>
              <a href="https://www.x.com" target="_blank" class="clickable-div">
                <img src="@/assets/x.svg" />
              </a>
            </div>
          </div>

          <div v-if="!isLargeScreen" class="social-media-links">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              class="clickable-div"
            >
              <img src="@/assets/linkedin.svg" />
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              class="clickable-div"
            >
              <img src="@/assets/facebook.svg" />
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              class="clickable-div"
            >
              <img src="@/assets/instagram.svg" />
            </a>
            <a href="https://www.x.com" target="_blank" class="clickable-div">
              <img src="@/assets/x.svg" />
            </a>
          </div>
          <div v-if="!isLargeScreen">
            <p class="white-text">
              Succour helps families and individuals connect with verified
              caregivers faster
            </p>
          </div>
          <div
            class="footer-section"
            v-for="(section, index) in footerSections"
            :key="index"
          >
            <div class="footer-header" @click="toggleSection(index)">
              <p class="footer-header-text">{{ section.title }}</p>
              <img
                v-if="!isLargeScreen"
                src="@/assets/dropdown_icon_white.svg"
                alt=""
                :class="{ open: isOpen(index) }"
              />
            </div>
            <div v-if="isLargeScreen || isOpen(index)">
              <router-link
                style="margin-bottom: 8px"
                v-for="(link, i) in section.links"
                :key="i"
                :to="link.url"
                >{{ link.text }}</router-link
              >
            </div>
          </div>
        </div>
        <div v-if="!isLargeScreen" class="logoandsocialmedia">
          <img
            src="@/assets/white_logo.svg"
            style="width: 167.32px; height: 60.05px; margin-bottom: 16px"
            alt="Logo"
          />
        </div>

        <div class="ft">
          Copyright © {{ currentYear }} Succour Company S.L. All rights
          reserved.
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import BaseButton from "@/components/BaseButton.vue";

export default {
  name: "DashboardLayout",
  components: {
    BaseButton,
  },
  setup() {
    const userProfile = JSON.parse(localStorage.getItem("_userProfile"));
    console.log("user profile fam", userProfile);
    const careType = ref(userProfile.type);
    const router = useRouter();
    const redirectToHome = () => {
      if (careType.value == "Care seeker") {
        router.push("/careseeker");
      } else {
        router.push("/caregiver");
      }
    };

    const isDropdownOpen = ref(false);
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const isAccountDropdownOpen = ref(false);
    const toggleAccountDropdown = () => {
      isAccountDropdownOpen.value = !isAccountDropdownOpen.value;
    };
    const isMobileMenuOpen = ref(false);
    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value;
    };

    const logout = () => {
      console.log("Logged out");
      router.push("/login");
      localStorage.clear();
      // Implement logout functionality here
    };
    const openSection = ref(null);

    const footerSections = [
      {
        title: "About",
        links: [
          { text: "Company", url: "/about-us" },
          { text: "FAQ", url: "/faq" },
          { text: "Terms of use", url: "/terms-of-use" },
          { text: "Privacy policy", url: "/privacy-policy" },
        ],
      },

      {
        title: "Services",
        links: [
          { text: "Child care", url: "/onboarding" },
          { text: "Elderly care", url: "/onboarding" },
          { text: "Housekeeper", url: "/onboarding" },
          { text: "Tutor", url: "/onboarding" },
        ],
      },
    ];

    const toggleSection = (index) => {
      openSection.value = openSection.value === index ? null : index;
    };

    const isOpen = (index) => openSection.value === index;
    const currentYear = computed(() => new Date().getFullYear());
    const isLargeScreen = ref(window.innerWidth > 1200);

    const handleResize = () => {
      isLargeScreen.value = window.innerWidth > 1200;
      console.log("inner", window.innerWidth);
    };
    return {
      redirectToHome,
      isDropdownOpen,
      toggleDropdown,
      isMobileMenuOpen,
      toggleMobileMenu,
      logout,
      careType,
      userProfile,
      footerSections,
      toggleSection,
      isOpen,
      currentYear,
      isLargeScreen,
      handleResize,
      isAccountDropdownOpen,
      toggleAccountDropdown,
    };
  },
};
</script>


<style scoped>
.dashboard-container {
  position: relative;
  width: 1188px;
  display: flex;
  justify-content: center;
  height: 100%;
}
.header-header {
  display: flex;
  width: 100%;
  justify-content: center;
}
.login-layout-container {
  background-color: #fffbfc;
  min-height: 100vh;
}
.main {
  background-color: #fff8f9;
  min-height: 100vh;
  width: 100%;
  padding-bottom: 200px;
}
.navbar {
  display: flex;
  padding: 32px 0px;
  justify-content: space-between;
  width: 100%;
  width: 1184px;
  box-sizing: border-box;
}
.header-header {
  box-shadow: 0px 4px 1px 0px #0000001a;
}
.main-logo {
  width: 168px;
  height: 59px;
  cursor: pointer;
}
.links {
  display: flex;
  gap: 30px;
}

.normal-links {
  color: var(--s-green-normal-darker);
  text-decoration: none;
  font-size: var(--font-body-normal-regular-size);
  line-height: var(--font-body-normal-regular-line-height);
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease;
}

.links router-link:hover {
  background-color: #007bff;
  color: #fff;
}
.links a {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
}

.links router-link-active {
  font-weight: bold;
}
.join-now {
  background-color: var(--s-pink-normal);
  width: 150px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--state-white);
  text-decoration: none;
  font-size: var(--font-body-normal-regular-size);
  line-height: var(--font-body-normal-regular-line-height);
}
.join-now-graded {
  background-color: #ececec;
  width: 150px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--state-white);
  text-decoration: none;
  font-size: var(--font-body-normal-regular-size);
  line-height: var(--font-body-normal-regular-line-height);
  pointer-events: none; /* This disables the click */
}
.header-header {
  background-color: #fff8f9;
}
.main-one {
  padding: 0px 0px 64px 0px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.find-care-container {
  background-color: var(--state-white);
  display: flex;
  justify-content: center;
  margin-top: 31px;
  padding-bottom: 51px;
  width: 100%;
}

.header-text {
  color: var(--s-green-darker);
  font-size: 54.1px;
  font-weight: 700;
  line-height: 70.32px;
  letter-spacing: 0.9634920597076416px;
}

.find-job-care-provider {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: var(--s-pink-normal);
  padding-top: 108.5px;
  padding-bottom: 108.5px;
  gap: 48px;
}
.find-job-care-provider {
  background-image: url("@/assets/Layer1.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: var(--state-white);
  font-size: 36px;
  font-weight: var(--font-weight-bold);
  line-height: 52px;
  letter-spacing: 0.5px;
  text-align: center;
}
.main-three {
  background-image: url("@/assets/rectanglebackground.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-end;
  padding-top: 49px;
  padding-bottom: 49px;
  padding-right: 91px;
}
.get-started-card {
  display: flex;
  flex-direction: column;
  background-color: var(--state-white);
  border-radius: 12px;
  padding: 16px 0px 16px 16px;
  gap: 8px;
}
.get-started-card-image-div {
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  align-items: center;
  width: 546px;
}
.get-started-card-image-div p {
  font-size: 24px;
  font-weight: 700;
  line-height: 31.2px;
  letter-spacing: 0.5px;
  text-align: left;
}
.get-started-card-image-div img {
  height: 40px;
  width: 40px;
}
.get-started-card-extra-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
}
.button-get-started {
  background-color: var(--s-pink-normal);
  color: var(--state-white);
  width: 546px;
  padding: 16px 24px 16px 24px;
  gap: 10px;
  border-radius: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
}
.button-get-started a {
  outline: none;
  color: var(--state-white);
  text-decoration: none;
}
.main-three-header p {
  font-size: 36px;
  font-weight: 700;
  line-height: 52px;
  letter-spacing: 0.5px;
  color: var(--s-green-darker);
}
.main-three-header {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}
.footer {
  padding: 52px 134px 59px 157px;
  background-color: var(--s-green-normal);
}
.footer-content-container {
  display: flex;
  justify-content: space-between;
}
.social-media-links {
  display: flex;
  justify-content: flex-start;
  gap: 20.58px;
}
.social-media-links a {
  outline: none;
}
.logoandsocialmedia {
  display: flex;
  flex-direction: column;
}
.footer-content-container > div {
  max-width: 220px;
}
.white-text {
  color: #ffffff;
  font-size: 15.22px;
  font-weight: 400;
  line-height: 25.87px;
  letter-spacing: 0.5434070825576782px;
  text-align: justified;
}
.footer-header-text {
  font-size: 20px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  color: var(--state-white);
}
.footer-section > div:first-child {
  margin-bottom: 16px;
}
.footer-section > div:not(:first-child) {
  margin-bottom: 8px;
}
.footer-section > div:not(:first-child) a {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  color: var(--state-white);
  text-decoration: none;
}

.profile-dropdown {
  position: relative;
}

.profile-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.profile-initials {
  background-color: #d3e0dc;
  border-radius: 50%;
  width: 47px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
}

.dropdown-arrow {
  transition: transform 0.3s ease;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.dropdown-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  text-align: center;
}
.dropdown-header p {
  font-size: 20px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0.5px;
}

.dropdown-section {
  padding: 10px;
}

.dropdown-title {
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid black;

  font-size: 16px;
  font-weight: 700;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
}

.dropdown-section ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.dropdown-section li {
  padding: 5px 0;
  cursor: pointer;

  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
}

.dropdown-section li:hover {
  background-color: #f0f0f0;
}

.dropdown-footer {
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.dropdown-footer button {
  background-color: #17865f;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 5px 10px;
  cursor: pointer;
}

.dropdown-footer button:hover {
  background-color: #0f5c3e;
}
li a {
  text-decoration: none;
  cursor: pointer;

  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #000000 !important;
}

.dropdown-menu {
  position: absolute;
  top: calc(
    100% + 32px
  ); /* Adjust this value based on the height of the header */
  right: 0px;
  width: 367px;
  border: 1px solid #64ae94;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  background-color: white;
  z-index: 1000;
}
.active-link {
  color: var(--s-green-normal);
}

.active-link svg path {
  fill: var(--s-green-normal);
}

.menu-icon {
  display: none;
  cursor: pointer;
}

.mobile-menu {
  display: none;
  flex-direction: column;
  /* position: absolute; */
  /* top: 100%;
  right: 0; */
  background-color: #fff;

  padding: 10px;
}

.mobile-link {
  padding: 10px;
  /* border-bottom: 1px solid #eee; */
  text-decoration: none;
  color: #000;
}
.footer-header-text {
  font-size: 20px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  color: var(--state-white);
}
.footer-section > div:first-child {
  margin-bottom: 16px;
}
.footer-section > div:not(:first-child) {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}
.footer-section > div:not(:first-child) a {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  color: var(--state-white);
  text-decoration: none;
}
.ft {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 11.9px;
  letter-spacing: 0.25px;
  text-align: center;
  color: #ffffff;
  margin-top: 36px;
}
@media (max-width: 800px) {
  .header-header {
    position: fixed;
    z-index: 1000;
  }
  .links > a {
    display: none;
  }
  .links {
    align-items: center;
    gap: 5px !important;
  }
  .links a {
    text-decoration: none;

    font-size: 10px;
  }
  .menu-icon {
    display: block;
  }

  .mobile-menu {
    position: fixed;
    display: flex;
    top: 66px;
    left: 0px;
    height: -webkit-fill-available;
    padding-bottom: 46px;
    z-index: 2000 !important;
    width: 300px;
    background: white;
  }
  .the-container {
    display: flex;
    width: 300px;
  }

  .footer {
    padding: 16px;
    background-color: var(--s-green-normal);
    width: 100%;
  }
  .footer-content-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .upgrade-mobile {
    pointer-events: none;
  }
  .dropdown-menu {
    width: 250px;
  }
  .navbar {
    padding: 32px 20px;
  }
  .footer {
    padding: 20px;
    background-color: var(--s-green-normal);
    width: 100%;
  }
  .footer-content-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .footer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footer-content-container > div {
    max-width: 100%;
  }
  .footer-section {
    width: 100%;
  }
  .ft {
    font-family: Inter;
    font-size: 10px;
    font-weight: 400;
    line-height: 11.9px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #ffffff;
    margin-top: 36px;
  }
  .has-icon {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .has-logout {
    justify-content: space-between;
  }
  .navbar {
    padding: 10px 20px;
  }
  .main-logo {
    width: 130px;
    height: 46px;
  }
  .main-one {
    padding: 66px 0px 64px 0px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
